<div class="min-h-dvh flex items-center justify-center p-4">
  <div class="w-full max-w-80 rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
    <h1 class="mb-6 text-center text-xl font-semibold text-gray-900">Admin login</h1>

    <form [formGroup]="form" (ngSubmit)="login()" class="flex flex-col gap-4">
      <mat-form-field class="w-full" appearance="fill">
        <mat-label>Username</mat-label>
        <input
          matInput
          formControlName="username"
          placeholder="Admin username"
          autocomplete="username"
        />
        <mat-error *ngIf="form.get('username')?.hasError('required')">Username is required</mat-error>
        <mat-error *ngIf="form.get('username')?.hasError('minlength')">Username is too short</mat-error>
      </mat-form-field>

      <mat-form-field class="w-full" appearance="fill">
        <mat-label>Password</mat-label>
        <input
          matInput
          [type]="hidePassword ? 'password' : 'text'"
          formControlName="password"
          placeholder="Password"
          autocomplete="current-password"
        />
        <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword" aria-label="Toggle password visibility">
          <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        <mat-error *ngIf="form.get('password')?.hasError('required')">Password is required</mat-error>
        <mat-error *ngIf="form.get('password')?.hasError('minlength')">Password is too short</mat-error>
      </mat-form-field>

      <button
        mat-raised-button
        color="primary"
        type="submit"
        class="w-full"
        [disabled]="form.invalid || isSubmitting"
      >
        <span *ngIf="!isSubmitting">Log in</span>
        <span *ngIf="isSubmitting">Signing in…</span>
      </button>
    </form>
  </div>
</div>
